import { Meeting, PatientMeeting, MeetingType } from '../types/api';

/**
 * Get meeting type name with re_intake override logic
 * Handles both Meeting and PatientMeeting types
 */
export function getMeetingTypeName(
  meeting: Meeting | PatientMeeting,
  meetingTypes: MeetingType[]
): string {
  const type = meetingTypes.find(t => t.id === meeting.meetingtype_id);
  let typeName = type?.name || "-";

  // Check for re_intake (correct spelling) or re_inatke (legacy typo) fields
  const hasReIntake = ('re_intake' in meeting && meeting.re_intake) ||
                      ('re_inatke' in meeting && meeting.re_inatke);

  // Override meeting type name if re_intake is true
  if (hasReIntake) {
    if (meeting.meetingtype_id === 1 || meeting.meetingtype_id === 4) {
      typeName = "Case manager Re intake";
    } else if (meeting.meetingtype_id === 2 || meeting.meetingtype_id === 3) {
      typeName = "Psychiatrist Re intake";
    }
  }

  return typeName;
}

/**
 * Whether starting this meeting should also create the Recall.ai transcription bot
 * (the backend's /start_meeting endpoint, which is the only thing that creates one).
 *
 * Every video meeting does: CM intake (1) and both PSY types (2, 3), plus CM re-intakes,
 * which are type 4 with the re_intake flag. A plain type-4 follow-up is a phone call
 * recorded through Twilio, so it gets no bot.
 *
 * Handles both spellings of the flag: the calendar endpoints return re_intake, the
 * patient-page endpoint returns the legacy typo re_inatke.
 */
export function shouldStartRecallBot(meeting: {
  meetingtype_id?: number;
  re_intake?: boolean;
  re_inatke?: boolean;
} | null | undefined): boolean {
  const typeId = meeting?.meetingtype_id;
  if (typeId === 1 || typeId === 2 || typeId === 3) return true;
  return typeId === 4 && Boolean(meeting?.re_intake || meeting?.re_inatke);
}
